export default __webpack_public_path__ + "static/tanis-6b119971af4b2c58010430ccb29314e4.jpeg";